import { Component } from '@angular/core';

@Component({
  selector: 'uni-list-header',
  templateUrl: './uni-list-header.component.html',
  styleUrls: ['./uni-list-header.component.scss'],
})
export class UniListHeaderComponent {}
